import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import StockReport from './components/StockReport';
import FormButton from '@/components/DSE/FormButton';

export function getFormDefinition(vue) {
  return {
    type: 'tab',
    saveButtons: [true, false, false], // Page, tab 1, tab 2, ...
    showFormLabels: [true, false], // Tab 1, tab 2, ....
    labels: ['fabricStockReport.tabGeneral', 'fabricStockReport.stockReportData'],
    names: ['general', 'stockReportData'],
    groups: [
      {
        stockLocations: {
          type: Select,
          defaultValue: [],
          props: {
            caption: 'fabricStockReport.stockLocations',
            valueField: 'id',
            labelField: 'name',
            multiple: true,
            options: vue.$store.getters['stockLocation/loadedItems'],
            loading: vue.$store.getters['stockLocation/isLoading']
          }
        },
        fabricStatusOption: {
          type: Select,
          props: {
            caption: 'fabric.fabricStatusOption',
            valueField: 'code',
            labelField: 'description',
            multiple: true,
            loading: vue.$store.getters['option/isLoading'],
            options: vue.$store.getters['option/loadedOptions']('fabricStatus')
          }
        },
        includeAvailableAmount: {
          type: Switch,
          defaultValue: true,
          props: {
            caption: 'fabricStockReport.includeAvailableAmount',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        includeReservedAmount: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'fabricStockReport.includeReservedAmount',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        includeBlockedAmount: {
          type: Switch,
          defaultValue: false,
          props: {
            caption: 'fabricStockReport.includeBlockedAmount',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        includePositionCode: {
          type: Switch,
          defaultValue: true,
          props: {
            caption: 'fabricStockReport.includePositionCode',
            activeText: 'common.yes',
            inactiveText: 'common.no'
          }
        },
        createStockReportButton: {
          type: FormButton,
          props: {
            caption: 'common.emptyString',
            buttonText: 'common.createReport',
            onclick: vue.createStockReport
          }
        }
      },
      {
        stockReportData: {
          type: StockReport,
          props: {
            caption: 'common.emptyString'
          },
          dynamicProps: form => ({
            stockLocationsToReport: vue.getStockLocationsToReport(form),
            fabricStatusOptionsSelected: vue.$store.getters['option/loadedOptions']('fabricStatus').filter(
              fabricStatusOption =>
                form.fabricStatusOption && form.fabricStatusOption.some(code => fabricStatusOption.code === code)
            ),
            includeAvailableAmount: form.includeAvailableAmount,
            includeReservedAmount: form.includeReservedAmount,
            includeBlockedAmount: form.includeBlockedAmount,
            includePositionCode: form.includePositionCode
          })
        }
      }
    ]
  };
}

const layoutTabGeneral = {
  named: true,
  sections: [
    {
      width: 100,
      fields: [
        'stockLocations',
        'fabricStatusOption',
        'includeAvailableAmount',
        'includeReservedAmount',
        'includeBlockedAmount',
        'includePositionCode',
        'createStockReportButton'
      ]
    }
  ]
};

const layoutTabReport = {
  named: true,
  sections: [
    {
      width: 100,
      fields: ['stockReportData']
    }
  ]
};

export function getLayoutDefinition(vue) {
  return {
    groups: [layoutTabGeneral, layoutTabReport]
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
